// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';

export const FieldHolder = styled.div`
  padding: 0 0 20px;
`;

export const BtnHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
